import Topbar from './global/Topbar';
import Sidebar from './global/Sidebar';
import MobileMenu from './global/MobileMenu';
import { Box, useTheme } from '@mui/material';
import Cookies from 'universal-cookie';
import NewUserPersonalData from './components/new/NewUserPersonalData';
import { DevHighlighting } from './DevHighlighting';
import MailboxReauthReminder from './components/email-system/MailboxReauthReminder';
import {
  AiChatPanel,
  AiChatProvider,
  useAiPanel,
} from './components/ai-chat';
import { useLocation } from 'react-router-dom';
import { PageSuspense } from './global/PageSuspense';

const Layout = ({ children }) => (
  <AiChatProvider>
    <LayoutContent>{children}</LayoutContent>
  </AiChatProvider>
);

const LayoutContent = ({ children }) => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const aiPanel = useAiPanel();
  const hideMain = aiPanel.open && aiPanel.fullscreen && !aiPanel.compact;
  const location = useLocation();

  // get background image
  const cookies = new Cookies();
  const storedBackgroundImageDark = cookies.get('backgroundImageDark')
    ? cookies.get('backgroundImageDark')
    : '/assets/uploads/background-dark.webp';
  const storedBackgroundImageLight = cookies.get('backgroundImageLight')
    ? cookies.get('backgroundImageLight')
    : '/assets/uploads/background-bright.webp';

  return (
    <div className="h-dvh-safe">
      <Box
        className="fixed top-0 left-0 w-full h-full -z-10"
        sx={{
          backgroundImage:
            mode === 'dark'
              ? 'url(' + storedBackgroundImageDark + ')'
              : 'url(' + storedBackgroundImageLight + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center bottom',
        }}
      />
      <DevHighlighting className="app flex flex-col-reverse sm:flex-row h-full overflow-hidden relative">
        <Sidebar />
        <MobileMenu />
        <main
          className="min-h-full md:h-full w-full overflow-auto sm:overflow-hidden flex flex-col pb-9 sm:pb-0 relative"
          style={hideMain ? { display: 'none' } : undefined}
        >
          <Topbar />
          <Box className="px-0 pt-2 sm:p-4 sm:h-full flex flex-col gap-1 sm:overflow-hidden ">
            {/* pages load on first visit; sidebar and topbar stay meanwhile */}
            <PageSuspense resetKey={location.pathname}>{children}</PageSuspense>
          </Box>
        </main>
        <AiChatPanel />
        <NewUserPersonalData />
        <MailboxReauthReminder />
      </DevHighlighting>
    </div>
  );
};

export default Layout;
